import SpecialtyEventUploadView from './SpecialtyEventUploadView';

export default SpecialtyEventUploadView;
